// extracted by mini-css-extract-plugin
module.exports = {"player-icon-mask":"ee","playerIconMask":"ee","player-icon-box":"ef","playerIconBox":"ef"};